import React, { useEffect, useState } from "react"
import { Form, Row, Container, Table, Label, Col } from "reactstrap"
import Select from "react-select"
import Swal from "sweetalert2"
import secureLocalStorage from "react-secure-storage"
import {
    fetchData,
    fetchNodeData,
    FetchNodePostData,
    FetchPostData,
} from "utils/common-fetchData"
import Loader from "pages/Separate/Loader"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import { useLocation, useNavigate } from "react-router-dom"
import axios from "axios"
import {
    colourStyles,
    developmentProjectType,
    ResourceType,
} from "utils/common-options"
import configure from "configure"

const MaintProjects = ({ stageData, getFetchStep }) => {
    const token = secureLocalStorage.getItem("auth_token")
    const userId = localStorage.getItem("auth_id")
    const navigate = useNavigate()
    const [isLoading, setLoading] = useState(false)
    const [fixButtons, setFixButtons] = useState(false)

    // Existing State
    const [project, setProject] = useState(null)
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [totalHours, setTotalHours] = useState({
        new: 0,
        maintenance: 0,
        carry: "no",
        total: 0,
    })
    const [contract, setContract] = useState(null)
    const [contractOption, setContractOption] = useState([])
    const [projectFromGitOption, setProjectFromGitOption] = useState([])
    const [projectName, setProjectName] = useState("")
    const [projectScope, setProjectScope] = useState([])

    // New State from AddProject
    const [locationOption, setLocationOption] = useState([])
    const [customerOptions, setCustomerOptions] = useState([])
    const [allKeyIndustryOption, setAllKeyIndustryOption] = useState([])
    const [sourceOption, setSourceOption] = useState([])
    const [projectReferenceOptions, setProjectReferenceOptions] = useState([])
    const [projectKeyManagerOptions, setProjectKeyManagerOptions] = useState([])
    const [projectScrumOptions, setProjectScrumOptions] = useState([])
    const [projectMembersOptions, setProjectMembersOptions] = useState([])
    const [location, setLocation] = useState(null)
    const [projectTypeSelect, setProjectTypeSelect] = useState(null)
    const [projectSource, setProjectSource] = useState(null)
    const [projectReference, setProjectReference] = useState(null)
    const [projectResourceType, setProjectResourceType] = useState(null)
    const [projectCustomer, setProjectCustomer] = useState(null)
    const [projectIndustry, setProjectIndustry] = useState(null)
    const [projectDescription, setProjectDescription] = useState("")
    const [projectKeyManager, setProjectKeyManager] = useState(null)
    const [projectScrumMaster, setProjectScrumMaster] = useState(null)
    const [projectMembers, setProjectMembers] = useState([])
    const [projectTotalHours, setProjectTotalHours] = useState("")
    const [hoursPerWeek, setHoursPerWeek] = useState("")
    const [projectEstHour, setProjectEstHour] = useState("")
    const [projectEstWeeks, setProjectEstWeeks] = useState("")
    const [estimatedEndDate, setEstimatedEndDate] = useState("")
    const [deliveryDate, setDeliveryDate] = useState("")
    const [kamHours, setKamHours] = useState(0)
    const [frontHours, setFrontHours] = useState(0)
    const [endHours, setEndHours] = useState(0)
    const [testHours, setTestHours] = useState(0)
    const [deployHours, setDeployHours] = useState(0)
    const [allProjects, setAllProjects] = useState([])
    const [projectData, setProjectData] = useState()

    // Task State
    const [formRows2, setFormRows2] = useState([{}])
    const priorityOption = [
        { value: "1", label: "High" },
        { value: "2", label: "Medium" },
        { value: "3", label: "Low" },
    ]

    const toggleLoading = loading => {
        setLoading(loading)
    }

    const setProjectContract = data => {
        setContract(data)
        setProjectScope(data.project_scope)
    }


    const fetchProjectData = async () => {
        const res = await fetchData(toggleLoading, "projectRelatedData", token)
        if (res?.success) {
            const { data } = res
            const {
                projects,
                contract,
                location,
                source,
                customer,
                introducer,
                industry,
                keymanager,
                scrum,
                developers,
            } = data
            const createOptions = (items, label, value) =>
                items?.map(item => ({ label: item?.[label], value: item?.[value] }))
            setProjectFromGitOption(createOptions(projects, "project_name", "id"))
            setContractOption(
                contract?.map(obj => ({
                    value: obj?.id,
                    label: `${obj?.id}-${obj?.company_name}-${obj?.service}`,
                    project_scope: obj?.project_scope,
                }))
            )
            setLocationOption(createOptions(location, "location", "id"))
            setSourceOption(
                source?.map(obj => ({
                    value: obj?.id,
                    label: obj?.leadname,
                    customerOption: createOptions(customer, "company", "id"),
                    introducerOption: createOptions(introducer, "company", "id"),
                    ...obj
                }))
            )
            setCustomerOptions(createOptions(customer, "company", "id"))
            setProjectCustomer(createOptions(customer, "company", "id")?.find((obj) => obj?.value == stageData?.customer_id))
            setAllKeyIndustryOption(createOptions(industry, "name", "id"))
            setProjectKeyManagerOptions(createOptions(keymanager, "name", "id"))
            setProjectScrumOptions(createOptions(scrum, "name", "id"))
            setProjectMembersOptions(createOptions(developers, "name", "id"))
        }
    }

    const fetchCompletedProjects = async () => {
        try {
            // const res = await axios.get(
            // `${configure.localUrl}completedProjects`,)
            const res = await fetchNodeData(toggleLoading, `completedProjects`)

            if (res?.status) {
                const projects = res.data || []
                const createOptions = (items, label, value) =>
                    items.map(item => ({
                        label: item?.[label],
                        value: item?.[value],
                    }))
                setAllProjects(createOptions(projects, "project_name", "id"))
            } else {
                console.warn(
                    "No completed projects found or API returned unsuccessful response."
                )
                setAllProjects([])
            }
        } catch (err) {
            console.error("Error fetching completed projects:", err)
            setAllProjects([])
        }
    }

    useEffect(() => {
        fetchProjectData()
        fetchCompletedProjects()
    }, [])

    const onAddFormRow2 = () => {
        setFormRows2([
            ...formRows2,
            { task: "", hours: "", probability: "", priority: "", description: "" },
        ])
    }

    const onUpdateTaskRow = (index, value) => {
        const updatedRows = [...formRows2]
        updatedRows[index].task = value
        setFormRows2(updatedRows)
    }

    const onUpdateHoursRow = (index, value) => {
        const updatedRows = [...formRows2]
        updatedRows[index].hours = value
        setFormRows2(updatedRows)
    }

    const onUpdateProbabilityRow = (index, value) => {
        const updatedRows = [...formRows2]
        updatedRows[index].probability = value
        setFormRows2(updatedRows)
    }

    const onUpdatePriorityRow = (index, value) => {
        const updatedRows = [...formRows2]
        updatedRows[index].priority = value
        setFormRows2(updatedRows)
    }

    const onUpdateDescriptionRow = (index, value) => {
        const updatedRows = [...formRows2]
        updatedRows[index].description = value
        setFormRows2(updatedRows)
    }

    const onDeleteFormRow2 = index => {
        setFormRows2(formRows2.filter((_, i) => i !== index))
    }

    const handleToggleClick = () => {
        setTotalHours(prev => ({
            ...prev,
            carry: prev.carry === "yes" ? "no" : "yes",
        }))
    }

    const onSubmit = async e => {
        e.preventDefault()
        const onAdd = async () => {
            setLoading(true)
            if (
                projectType !== "existing" &&
                Number(projectEstHour) < projectTotalHours
            ) {
                setLoading(false)
                Swal.fire({
                    icon: "warning",
                    text: "Total allocated hours cannot exceed estimated hours.",
                })
                return
            }

            const formEntries = {
                projectType,
                user_id: userId,
                ...(projectType === "existing"
                    ? { project_id: project?.value }
                    : {
                        project_name: projectName,
                        projectbelongsto: location?.value,
                        project_type: 3,
                        source: projectSource?.value,
                        resource_type: projectResourceType?.value,
                        customer: projectCustomer?.value,
                        industry: projectIndustry?.value,
                        description: projectDescription,
                        keyaccountmanager: projectKeyManager?.value,
                        scrum_master: projectScrumMaster?.value || null,
                        member: projectMembers?.map(obj => obj?.value)?.join(","),
                        total_hrs:
                            parseInt(totalHours.maintenance) + parseInt(totalHours.new),
                    }),
                contract: contract?.value,
                start_date: startDate,
                end_date: endDate,
                new_development_hrs: totalHours.new,
                maintenance_hrs: totalHours.maintenance,
                carry_forward: totalHours.carry,
                tasks: formRows2.map(row => ({
                    title: row.task,
                    estimation_days: parseInt(row.hours),
                    probability: parseInt(row.probability),
                    priority: parseInt(row.priority),
                    description: row.description,
                })),
            }

            try {
                const res = await FetchNodePostData(
                    toggleLoading,
                    `addMaintenanceProject`,
                    token,
                    formEntries
                )
                setLoading(false)

                if (res.data.status === true) {
                    Swal.fire({
                        icon: "success",
                        text: "New Maintenance Project created successfully.",
                    }).then(async () => {
                        const formEntries = {
                            id: stageData?.id,
                            stage: 3,
                            project_type:2,
                            project_id: res?.data?.data?.newProject?.id
                        }
                        const response = await FetchNodePostData(setLoading, 'stageProcess', token, formEntries);
                        if (response?.data?.success) {
                            getFetchStep()
                        }
                    })
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Failed to create project.",
                    })
                }
            } catch (err) {
                setLoading(false)
                console.error("Submission error:", err)
                Swal.fire({
                    icon: "error",
                    text: "Something went wrong while submitting the project.",
                })
            }
        }

        if (stageData?.stage > 3) {
            Swal.fire({
                icon: 'warning',
                title: "Are You sure?",
                text: "Again you want to add New Project as you have already saved & moved to next step?",
                showCancelButton: true,
                confirmButtonText: 'Yes, Create it!',
                cancelButtonText: 'No, cancel!',
            }).then((isOkay) => {
                if (isOkay?.isConfirmed) {
                    onAdd()
                }
            })
        } else {
            onAdd()
        }
    }

    const locationHook = useLocation()
    const [projectType, setProjectType] = useState("new")

    useEffect(() => {
        const hashValue = locationHook.hash.replace("#", "")
        if (hashValue) {
            setProjectType(hashValue)
        }
    }, [locationHook.hash])

    useEffect(() => {
        const handleScroll = () => {
            setFixButtons(window.scrollY > 360)
        }
        document.addEventListener("scroll", handleScroll)
        return () => document.removeEventListener("scroll", handleScroll)
    }, [])

    return (
        <>
            {isLoading && <Loader />}
            <form className="" onSubmit={onSubmit}>
                <Row className="bg-white py-4 shadow mb-3 px-2 mb-3 align-items-center">
                    <div className="d-flex gap-2 justify-content-between">
                        <h5 className="mb-3">Project Basic Details</h5>
                        <div >
                            <button
                                className="btn ms-md-2 btn-save btn-label"
                            >
                                <i className="fas fa-save me-1 label-icon"></i> save
                            </button>
                        </div>
                    </div>
                    <div className="col-md-3 mt-3 mb-3">
                        <label htmlFor="">
                            Project Belongs To{" "}
                            <span className="text-danger">*</span>
                        </label>
                        <Select
                            placeholder="Project Belongs To"
                            required
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={locationOption}
                            value={location}
                            onChange={e => setLocation(e)}
                        />
                    </div>
                    <div className="col-md-9 mt-3 mb-3">
                        <label htmlFor="">
                            Project Name <span className="text-danger">*</span>
                        </label>
                        <input
                            type="text"
                            placeholder="Enter Project Name"
                            required
                            className="form-control"
                            value={projectName}
                            onChange={e => setProjectName(e.target.value)}
                        />
                    </div>
                    <div className="row">
                        <div className="col-md-4 mb-2">
                            <label htmlFor="">
                                Select Contract <span className="text-danger">*</span>
                            </label>
                            <Select
                                placeholder="Select Contract"
                                required
                                className="basic-multi-select"
                                classNamePrefix="select"
                                options={contractOption}
                                value={contract}
                                onChange={setProjectContract}
                            />
                        </div>
                        <div className="col-md-4 mb-2">
                            <label htmlFor="formrow-startdate-Input">
                                Start Date <span className="text-danger">*</span>
                            </label>
                            <input
                                type="date"
                                className="form-control"
                                required
                                id="formrow-startdate-Input"
                                value={startDate}
                                onChange={e => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="col-md-4 mb-2">
                            <label htmlFor="formrow-enddate-Input">
                                End Date <span className="text-danger">*</span>
                            </label>
                            <input
                                type="date"
                                className="form-control"
                                required
                                id="formrow-enddate-Input"
                                value={endDate}
                                onChange={e => setEndDate(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-md-4 mb-4">
                        <label htmlFor="formrow-newhours-Input">
                            New Development Hours{" "}
                            <span className="text-danger">*</span>
                        </label>
                        <input
                            type="number"
                            placeholder="New Development Hours"
                            className="form-control"
                            required
                            id="formrow-newhours-Input"
                            value={totalHours.new}
                            onChange={e =>
                                setTotalHours({
                                    ...totalHours,
                                    new: e.target.value,
                                })
                            }
                        />
                    </div>
                    <div className="col-md-4 mb-4">
                        <label htmlFor="formrow-maintenancehours-Input">
                            Maintenance Hours <span className="text-danger">*</span>
                        </label>
                        <input
                            type="number"
                            placeholder="Maintenance Hours"
                            className="form-control"
                            id="formrow-maintenancehours-Input"
                            required
                            value={totalHours.maintenance}
                            onChange={e =>
                                setTotalHours({
                                    ...totalHours,
                                    maintenance: e.target.value,
                                })
                            }
                        />
                    </div>
                    <div className="col-md-3 mb-4">
                        <div className="d-flex align-items-center justify-content-start">
                            <label
                                htmlFor="carryForwardSwitch"
                                className={`mb-0 f-15 ${totalHours.carry === "yes"
                                    ? "text-success"
                                    : "text-danger"
                                    }`}
                            >
                                New dev. Hrs. Carry Forward:{" "}
                                {totalHours.carry === "yes" ? "Yes" : "No"}
                            </label>
                            <div className="form-switch form-switch-md">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="carryForwardSwitch"
                                    onClick={handleToggleClick}
                                    checked={totalHours.carry === "yes"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <small className="text-danger">
                            * Maintenance hours must be entered on a per month
                            basis.
                        </small>
                    </div>
                    <div className="col-md-11 mb-3 d-flex justify-content-start align-items-center gap-5">
                        <div className="col-md-3 mt-2 mb-3 mb-md-0">
                            <label htmlFor=""> Source</label>
                            <Select
                                placeholder="Select Source"
                                className="basic-multi-select"
                                classNamePrefix=" select"
                                options={sourceOption?.filter((obj) => obj?.location == location?.value)}
                                value={projectSource}
                                onChange={e => {
                                    setProjectSource(e)
                                    if (e.label?.toLowerCase() == "introducer") {
                                        setProjectReferenceOptions(e.introducerOption)
                                    } else if (e.label?.toLowerCase() == "customer") {
                                        setProjectReferenceOptions(e.customerOption)
                                    }
                                }}
                            />
                        </div>
                        <div className="col-md-3 mb-3 mt-2 mb-md-0">
                            <label htmlFor="">
                                Select {projectSource?.label || ""}
                            </label>
                            <Select
                                placeholder={`Select ${projectSource?.label || ""}`}
                                className="basic-multi-select"
                                classNamePrefix=" select"
                                options={projectReferenceOptions}
                                value={projectReference}
                                onChange={selectedOption =>
                                    setProjectReference(selectedOption)
                                }
                            />
                        </div>
                        <div className="col-md-3 mt-2 mb-3 mb-md-0">
                            <label htmlFor="">
                                Resource Type <span className="text-danger">*</span>
                            </label>
                            <Select
                                placeholder="Select Resource Type"
                                className="basic-multi-select"
                                required
                                classNamePrefix="select"
                                options={ResourceType}
                                value={projectResourceType}
                                onChange={selectedOption =>
                                    setProjectResourceType(selectedOption)
                                }
                            />
                        </div>
                        <div className="col-md-3 mb-3 mt-2 mb-md-0">
                            <label htmlFor="">
                                Customer <span className="text-danger">*</span>
                            </label>
                            <Select
                                placeholder="Select Customer"
                                className="basic-multi-select"
                                classNamePrefix="select"
                                required
                                options={customerOptions}
                                isDisabled
                                value={projectCustomer}
                                onChange={selectedOption =>
                                    setProjectCustomer(selectedOption)
                                }
                            />
                        </div>
                    </div>
                    <div className="col-md-4 mt-2 mb-3">
                        <label htmlFor="">Key Account Manager</label>
                        <Select
                            placeholder="Select Key Account Manager"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={projectKeyManagerOptions}
                            value={projectKeyManager}
                            onChange={e => setProjectKeyManager(e)}
                        />
                    </div>
                    <div className="col-md-4 mt-2 mb-3">
                        <label htmlFor="">Scrum Master</label>
                        <Select
                            placeholder="Select Scrum Master"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={projectScrumOptions}
                            value={projectScrumMaster}
                            onChange={e => setProjectScrumMaster(e)}
                        />
                    </div>
                    <div className="col-md-4 mt-2 mb-3">
                        <label htmlFor="">
                            Project Industry{" "}
                            <span className="text-danger">*</span>
                        </label>
                        <Select
                            placeholder="Select Industry"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            required
                            options={allKeyIndustryOption}
                            value={projectIndustry}
                            onChange={selectedOption =>
                                setProjectIndustry(selectedOption)
                            }
                        />
                    </div>
                    <div className="col-md-12 mb-3 d-flex justify-content-start align-items-center gap-4"></div>
                    <div className="col-12 mb-3">
                        <label htmlFor="">Description</label>
                        <CKEditor
                            editor={ClassicEditor}
                            data={projectDescription}
                            onChange={(event, editor) => {
                                const data = editor.getData()
                                setProjectDescription(data)
                            }}
                        />
                    </div>
                    {contract && (
                        <div className="col-md-12 row mb-4">
                            <div className="col-md-12">
                                <div className="d-flex justify-content-between align-items-center px-0 mb-3">
                                    <label htmlFor="">
                                        Scopes <span className="text-danger">*</span>
                                    </label>
                                </div>
                                {projectScope?.split("@#").map((obj, i) => (
                                    <div
                                        className="row align-items-center mt-2"
                                        key={i}
                                    >
                                        <div className="col-md-10">
                                            <i className="mdi mdi-chevron-right text-primary me-1"></i>
                                            <span className="mb-0 text-purple fs-6">
                                                {obj}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <Row className="px-0">
                        <div className="col-md-12">
                            <Row className="px-2 py-4 mb-3">
                                <div className="col-md-12 row mb-4">
                                    <div className="col-md-12">
                                        <div className="d-flex justify-content-between align-items-center px-0 mb-3">
                                            <label htmlFor="">
                                                Add Tasks{" "}
                                                <span className="text-danger">*</span>
                                            </label>
                                            <div className="text-end">
                                                <button
                                                    onClick={e => {
                                                        e.preventDefault()
                                                        onAddFormRow2()
                                                    }}
                                                    className="btn btn-purple"
                                                >
                                                    <i className="fas fa-plus me-2"></i>
                                                    Task
                                                </button>
                                            </div>
                                        </div>
                                        {formRows2.map((row, key) => (
                                            <div className="mb-3 p-2" key={key}>
                                                <div className="d-flex justify-content-start align-items-center gap-2 flex-wrap mb-2">
                                                    <input
                                                        type="text"
                                                        name="title"
                                                        placeholder="Enter Title"
                                                        className="form-control me-2"
                                                        style={{ maxWidth: "900px" }}
                                                        value={row.task}
                                                        onChange={e =>
                                                            onUpdateTaskRow(key, e.target.value)
                                                        }
                                                    />
                                                    <input
                                                        type="number"
                                                        name="estimated_hours"
                                                        placeholder="Est. Hours"
                                                        className="form-control me-2"
                                                        style={{ maxWidth: "150px" }}
                                                        value={row.hours}
                                                        onChange={e =>
                                                            onUpdateHoursRow(key, e.target.value)
                                                        }
                                                    />
                                                    <input
                                                        type="number"
                                                        name="probability"
                                                        placeholder="Probability"
                                                        className="form-control me-2"
                                                        style={{ maxWidth: "150px" }}
                                                        value={row.probability}
                                                        onChange={e => {
                                                            if (e.target.value > 100) {
                                                                Swal.fire({
                                                                    icon: "warning",
                                                                    text: "Probability cannot exceed 100.",
                                                                })
                                                            } else {
                                                                onUpdateProbabilityRow(
                                                                    key,
                                                                    e.target.value
                                                                )
                                                            }
                                                        }}
                                                    />
                                                    <Select
                                                        name="priority"
                                                        placeholder="Priority"
                                                        className="basic-multi-select me-2"
                                                        classNamePrefix="select"
                                                        options={priorityOption}
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            menuPortal: base => ({
                                                                ...base,
                                                                zIndex: 9999,
                                                            }),
                                                            control: base => ({
                                                                ...base,
                                                                minWidth: "150px",
                                                                maxWidth: "150px",
                                                            }),
                                                        }}
                                                        value={priorityOption.find(
                                                            option => option.value === row.priority
                                                        )}
                                                        onChange={option =>
                                                            onUpdatePriorityRow(key, option.value)
                                                        }
                                                    />
                                                    <button
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={e => {
                                                            e.preventDefault()
                                                            onDeleteFormRow2(key)
                                                        }}
                                                    >
                                                        <i className="fas fa-trash"></i>
                                                    </button>
                                                </div>
                                                <CKEditor
                                                    editor={ClassicEditor}
                                                    data={row.description}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData()
                                                        onUpdateDescriptionRow(key, data)
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Row>
                        </div>
                    </Row>
                </Row>
            </form>
        </>
    )
}

export default MaintProjects
